module.exports = __webpack_public_path__ + "img/rock-big-20.25bfead7.png";